import React from "react";
import { Card, CardContent, Typography, Box } from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";

const AdminStatCard = ({
  title,
  count,
  icon: Icon,
  color = "primary",
  percentage,
  onClick,
}) => {
  const theme = useTheme();
  const mainColor = theme.palette[color]?.main || theme.palette.grey[500];
  const lightColor = theme.palette[color]?.light || theme.palette.grey[100];
  const darkColor = theme.palette[color]?.dark || theme.palette.grey[700];

  return (
    <Box sx={{ cursor: "pointer" }} onClick={onClick}>
      <Card
        sx={{
          height: "100%",
          borderRadius: 4,
          borderBottom: `4px solid ${mainColor}`,
          boxShadow: `0 12px 24px -4px ${alpha(mainColor, 0.2)}`,
        }}
      >
        <CardContent>
          <Box
            sx={{
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "space-between",
            }}
          >
            <Box sx={{ width: "100%" }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  textWrap: "wrap",
                }}
              >
                <Typography
                  variant="subtitle1"
                  sx={{
                    color: "text.secondary",
                    letterSpacing: 0.5,
                    mb: 0.5,
                  }}
                >
                  {title}
                </Typography>

                <Box
                  sx={{
                    width: 56,
                    height: 56,
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: darkColor,
                    background: `linear-gradient(135deg, ${alpha(
                      lightColor,
                      0.2
                    )} 0%, ${alpha(darkColor, 0.2)} 100%)`,
                    boxShadow: `0 8px 16px -8px ${alpha(mainColor, 0.4)}`,
                  }}
                >
                  <Icon sx={{ fontSize: 32 }} />
                </Box>
              </Box>

              <Box
                sx={{
                  gap: 2,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-start",
                }}
              >
                <Typography
                  variant="h4"
                  sx={{ fontWeight: 700, color: "text.primary" }}
                >
                  {count}
                </Typography>

                {percentage && (
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Box
                      sx={{
                        display: "inline-flex",
                        alignItems: "center",
                        px: 1,
                        py: 0.5,
                        borderRadius: 1,
                        bgcolor:
                          percentage > 0
                            ? alpha(theme.palette.success.main, 0.1)
                            : alpha(theme.palette.error.main, 0.1),
                        color:
                          percentage > 0
                            ? theme.palette.success.dark
                            : theme.palette.error.dark,
                      }}
                    >
                      {percentage > 0 ? (
                        <ArrowUpwardIcon sx={{ fontSize: 14, mr: 0.5 }} />
                      ) : (
                        <ArrowDownwardIcon sx={{ fontSize: 14, mr: 0.5 }} />
                      )}
                      <Typography variant="caption" fontWeight="700">
                        {Math.abs(percentage).toFixed(1)}%
                      </Typography>
                    </Box>
                  </Box>
                )}
              </Box>
            </Box>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default AdminStatCard;
